import {Configuration} from "@api-clients/runtime";
import {GlobalCampaign} from "@api-clients/global/campaign/schema/GlobalCampaign";

export class FindGlobalCampaignApi {

    static async execute(
        configuration: Configuration,
        campaignId: string
    ): Promise<GlobalCampaign> {
        const response = await fetch(`${configuration.basePath}/a360/v1/campaigns/${campaignId}`, {
            method: 'GET',
            headers: configuration.headers,
        });

        return response.json();
    }

}
